import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';

import './AgentFeedback.scss';
import Modal from 'components/ModalProvider/Modal/Modal';
import SVG from 'components/SVG';
import crossSVG from '../../../img/cross.svg';
import Spinner from 'components/Spinner/desktop';
import useLinks from 'features/AgentFeedback/model/useLinks';

const b = block('agent-feedback');

const AgentFeedback = ({ closeFunction }) => {
  const locale = useSelector(state => state.locale.locale);

  const model = useLinks();

  return (
    <Modal
      closeFunction={closeFunction}
      content={
        <form className={b()} onSubmit={e => model.handleFormSubmit(e, 'feedback')}>
          <Spinner isLoading={model.actionProcessing} />

          <SVG className={b('cross')} svgProps={{ svg: crossSVG }} onClick={closeFunction} />
          <div className={b('text')}>{locale.contactLinkText}</div>
          <div className={b('input')}>
            <div className={b('input-label')}>{locale.link}</div>
            <Input
              value={model.state.links?.['feedback']?.link}
              onChange={e => model.onChangeLink('feedback', e.target.value)}
              placeholder={locale.link}
            />
          </div>
          <div className={b('button')}>
            <Button type="submit">{locale.save}</Button>
          </div>
        </form>
      }
    />
  );
};

export default AgentFeedback;
